import React, { useState, useContext } from "react";
import Button from "@mui/material/Button";
import Context from "../../../../context/Context";
import { Modal } from "react-bootstrap";
import './styles.css'

export const ImageModal = ({
  vagaoItens,
  status
}) => {

  const {
  } = useContext(Context);

  const [showImage, setShowImage] = useState(false);
  const handleShowImage = () => setShowImage(true)

  const handleCloseImage = () => {
    setShowImage(false)
  }


  return (
    <>
    {status !== "LIBERADO" && vagaoItens?.length > 0 && vagaoItens[0].image && (
      <div>
        <Button
          className="ms-2 mb-3"
          variant="contained"
          onClick={handleShowImage}
        >
          Foto
        </Button>

        <Modal show={showImage} onHide={handleCloseImage}>
          <img src={vagaoItens[0].image} alt="Imagem do vagão" />
        </Modal>
      </div>
    )}
  </>

  );
}